<template>
  <v-data-iterator
    :items="dataItems"
    :items-per-page="itemsPerPage"
    :loading="loading"
    :no-data-text="noDataText || local.common.noData"
    hide-default-footer
  >
    <template v-slot:default="{ items }">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <div
        v-for="(item , index) in items"
        :key="index"
        justify="space-around"
        align-items="align-stretch"
        class="mb-3"
      >
        <div class="card-row elevation-0">
          <v-hover v-slot="{ hover }">
            <div :class="[{'card-hover':hover, 'item-expanded': item.isExpand}]">
              <div
                :class="{ pointer: enableExpand }"
                class="info-item-box"
                @click="enableExpand && expand(item,index,!item.isExpand)"
              >
                <!-- <div
                  v-if="enableExpand"
                  class="info-item-details action-item justify-content-center expand-item px-6 py-0 clickable"
                  @click="expand(item,index,!item.isExpand)"
                >
                  <template>
                    <slot
                      name="expandButtonText"
                      :item="item"
                      :index="index"
                    />
                  </template>
                  <v-icon
                    v-if="!item.isExpand"
                    color="#ffffff"
                  >
                    mdi-arrow-down
                  </v-icon>
                  <v-icon
                    v-if="item.isExpand"
                    color="#ffffff"
                  >
                    mdi-arrow-up
                  </v-icon>
                </div> -->
                <router-link
                  :is="header.to && header.to(item) ? 'router-link':'div' "
                  v-for="header in headers"
                  :key="header.value"
                  :to="header.to?header.to(item):{}"
                  class="info-item-details d-flex justify-content-center pa-3"
                  :class="`${header.class || '' } ${enableExpand?' ':''}`"
                >
                  <template v-if="!header.isCustomTemplate">
                    <div
                      class="info-item-details-title"
                      :set="item.__value=item[header.value]"
                    >
                      <span v-if="header.text">{{ header.text }}</span>
                    </div>
                    <div
                      class="info-item-details-value"
                      :class="`${item['class-'+header.value] || '' }`"
                      :title="header.tooltipMode?(header.tooltipMode==tooltipMode.formatter && header.formatter?header.formatter(item.__value):item.__value):''"
                    >
                      <span> {{ !item.__value ? '—' : header.formatter ? header.formatter(item.__value) :item.__value }}</span>
                    </div>
                  </template>

                  <template v-else>
                    <slot
                      :name="header.value"
                      :item="item"
                      :index="index"
                    />
                  </template>
                </router-link>

                <v-icon
                  v-if="enableExpand && !item.isExpand"
                  class="expanded-icon"
                >
                  mdi-chevron-right
                </v-icon>
                <v-icon
                  v-if="enableExpand && item.isExpand"
                  class="expanded-icon"
                >
                  mdi-chevron-down
                </v-icon>
              </div>
              <v-col
                v-if="enableExpand && item.isExpand"
                dense
                cols="12"
                lg="12"
                class="pt-0"
              >
                <template>
                  <v-divider class="mt-0 pt-0"></v-divider>
                  <slot
                    name="expandSlot"
                    :item="item"
                    :index="index"
                  />
                </template>
              </v-col>
            </div>
          </v-hover>
        </div>
      </div>
    </template>
    <template v-slot:no-data>
      <slot name="noData" />
      <div
        v-if="!hideDefaultNoData"
        class="List__empty"
      >
        <img
          src="../../../public/img/folder.svg"
          alt="No information"
        >
        <h4 class="List__title">
          {{ noDataText || local.common.noData }}
        </h4>
      </div>
    </template>
    <template
      v-if="(dataItems || []).length==0"
      v-slot:loading
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <div class="List__empty">
        <img
          src="../../../public/img/folder.svg"
          alt="No information"
        >
        <h4 class="List__title">
          {{ loadingText ||local.common.loading }}...
        </h4>
      </div>
    </template>
    <template v-slot:footer>
      <div
        v-if="pagination"
        class="pagination-container"
      >
        <v-pagination
          :value="pagination.pageIndex + 1"
          :length="paginationLength"
          :total-visible="7"
          @input="$emit('update:page', $event)"
        ></v-pagination>
      </div>
    </template>
  </v-data-iterator>
</template>

<script>

export default {
  name: 'NajItemTable',
  props: {
    pagination: {
      type: Object,
      required: false,
      default: null,
    },
    dataItems: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      default: 1000,
      type: Number,
      required: false,
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    noDataText: {
      type: String,
      required: false,
      default: null,
    },
    loadingText: {
      type: String,
      required: false,
      default: null,
    },
    enableExpand: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDefaultNoData: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      data: { totalCount: 0 },
    };
  },
  computed: {
    paginationLength() {
      return Math.ceil(this.serverItemsLength / this.itemsPerPage);
    },
  },
  mounted() { },
  methods: {
    expand(item, index, value) {
      this.$set(this.dataItems[index], 'isExpand', value);
      for (let i = 0; i < this.dataItems.length; i++) {
        if (i != index)
          this.$set(this.dataItems[i], 'isExpand', false);
      }
      if (value) {
        this.$emit('expandSlot', item, index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-row {
  border: 1px solid #e4e5e6;
}
// .card-hover {
//   box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
//     0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
// }
.pagination-container {
  width: 100%;
  display: flex;
  justify-content: center;
  ::v-deep .v-pagination {
    .v-pagination__item,
    .v-pagination__navigation {
      border: 2px solid #d0d3db;
      border-radius: 50%;
      -webkit-box-shadow: none;
      box-shadow: none;
      height: 42px;
      width: 42px;
      line-height: 40px;
      font-size: 16px;
      color: #9ea1b3;
      &.v-pagination__item--active {
        color: #ffffff !important;
      }
    }
    .v-pagination__navigation {
      margin: 0 10px;
      .v-icon {
        font-size: 24px;
      }
    }
  }
}
.disable-items-per-page ::v-deep {
  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none;
  }
}

::v-deep {
  .List__empty {
    align-items: center;
    border: 1px solid #e4e5e6;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    margin-bottom: 24px;
    margin-top: 33px;
    padding: 16px;
    text-align: center;
    width: 100%;
  }
}
.List__title {
  font-weight: 700;
  font-size: 32px;
  line-height: 43px;
  margin: 32px 0 15px;
}
</style>

<style>
.info-item-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
  border-right: 2px solid #b69a70;
  border-left: 2px solid #b69a70;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  border-radius: 0.25rem 0.25rem 0 0;
  margin-bottom: 0;
  background-color: #f7f7f7;
  border-bottom: 0 solid #f7f7f7;
  line-height: normal;
}

.item-expanded > div:not(.info-item-box) {
  border-right: 2px solid #b69a70;
  border-left: 2px solid #b69a70;
  border-radius: 0 0 0.25rem 0.25rem;
}
.info-item {
  padding: 15px 10px;
  justify-content: center;
  padding-left: 30px;
  margin-left: 10px;
}

.info-item-details {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

.info-item-details-title {
  font-size: 0.9375rem;
  color: #34675a;
  font-weight: 700;
  margin-bottom: 6px;
  line-height: 16.5px;
  max-width: 100%;
}

.info-item-details-value {
  font-weight: 500;
  font-size: 15px;
  color: #34675a;
}

.btn-bt {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 5%;
  width: 1px;
  margin: auto;
}

.action-item {
  display: flex;
  flex: unset;
  justify-content: center;
}
.pointer {
  cursor: pointer;
}
.status-item {
  display: flex;
  max-width: 180px;
  min-width: 180px;
  flex: unset;
}

.expand-item {
  justify-content: flex-end;
  background-color: #158e8d;
  color: #ffffff;
  font-size: 14px;
}

.expanded-icon.mdi-chevron-down,
.expanded-icon.mdi-chevron-right {
  background: transparent;
  border: none;
  border-radius: 0;
  margin-left: 12px;
}
</style>
